import { MdOutlineHome, MdOutlineReport } from "react-icons/md";
import { BiUserPlus } from "react-icons/bi";
import { BsFilePlus, BsCollection } from "react-icons/bs";
import { FaUsers } from "react-icons/fa";
import { PiUserSquareFill } from "react-icons/pi";
import { MdOutlineFeedback } from "react-icons/md";

const MenuItems = [
  {
    path: "/dashboard",
    text: "Dashboard",
    icon: <MdOutlineHome />,
  },
  {
    path: "/users",
    text: "User & Access",
    icon: <BiUserPlus />,
  },
  {
    path: "/staff",
    text: "Staff",
    icon: <FaUsers />,
  },
  {
    path: "/master",
    text: "Master",
    icon: <BsFilePlus />,
    submenu: [
      {
        path: "/master/area",
        text: "Area",
      },
      {
        path: "/master/plan",
        text: "Plan",
      },
    ],
  },
  {
    path: "/customer",
    text: "Customer",
    icon: <PiUserSquareFill />,
  },

  {
    path: "/collection",
    text: "Collections",
    icon: <BsCollection />,
  },
  {
    path: "/complaint",
    text: "Complaint",
    icon: <MdOutlineFeedback />,
  },
  {
    path: "/report",
    text: "Report",
    icon: <MdOutlineReport />,
  },
];

export default MenuItems;
